module.exports = __webpack_public_path__ + "img/img2-1.3f922ff4.png";